import { useEffect, useId, useState, type ComponentType } from 'react';

type DeferredChartProps<T> = T & {
  fallbackHeight?: number;
  chartKey?: string;
};

export function createDeferredChart<T extends object>(ChartComponent: ComponentType<T>) {
  function DeferredChart({ fallbackHeight = 256, chartKey, ...props }: DeferredChartProps<T>) {
    const autoId = useId();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      const frame = requestAnimationFrame(() => setMounted(true));
      return () => {
        cancelAnimationFrame(frame);
        setMounted(false);
      };
    }, [chartKey ?? autoId]);

    if (!mounted) {
      return <div style={{ height: fallbackHeight }} aria-hidden />;
    }

    return (
      <ChartComponent
        key={chartKey ?? autoId}
        {...(props as T)}
        redraw
      />
    );
  }

  return DeferredChart;
}
